import { useContext } from "react";
import { KineContext } from "../providers/KineProvider";

const useKine = () => {
    const context = useContext(KineContext);
    if (context === null) {
        throw new Error('...');
    }

    return context;
}

export default useKine;